<template>
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 18L3.8 20.6C3.43 20.79 3 20.52 3 20.11V6.35C3 6.16 3.11 5.99 3.28 5.9L9 3L15 6L20.2 3.4C20.57 3.21 21 3.48 21 3.89V17.65C21 17.84 20.89 18.01 20.72 18.1L15 21L9 18Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
    <path d="M9 3V18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    <path d="M15 6V21" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: "MapIcon",
};
</script>
